// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.abttZC3cGQayDu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.onRPhPupkkwP18 {
  margin-bottom: var(--ds-space-075, 6px);
  color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
export var spinnerContainer = `abttZC3cGQayDu`;
export var spinnerMessage = `onRPhPupkkwP18`;
export default ___CSS_LOADER_EXPORT___;
